import dayjs from 'mixins/dayjsConfig.js';
import { DefaultOptionType } from 'rc-select/lib/Select';
import {
    QueueAvailableTime,
    QueueRegion,
    QueueServiceDeliveryCenter,
    QueueServiceName,
} from './booking-queue.types';

export const getValueByLangCode = (inputStr: string, langCode: string) => {
    const pairs = inputStr.split(';');

    for (var i = 0; i < pairs.length; i++) {
        var pair = pairs[i].split('=');

        if (pair[0] === langCode) {
            return pair[1];
        }
    }

    return null;
};

export const normalizeRegions = (data: QueueRegion[], lang: string): DefaultOptionType[] => {
    return (
        Array.isArray(data) &&
        data
            .sort((a, b) => {
                if (a.name[lang] > b.name[lang]) {
                    return 1;
                }
                if (a.name[lang] < b.name[lang]) {
                    return -1;
                }
                return 0;
            })
            .map((x) => ({
                label: x.name[lang],
                value: x.taxOrgCode,
                key: x.taxOrgCode,
            }))
    );
};

export const normalizeServiceNames = (
    data: QueueServiceName[],
    lang: string
): DefaultOptionType[] => {
    return (
        Array.isArray(data) &&
        data
            .map((x) => ({
                label: getValueByLangCode(x.workName, (lang === 'kk' ? 'KZ' : lang.toUpperCase())),
                value: x.serviceId,
                key: x.serviceId,
            }))
            .sort((a, b) => {
                if (a.label > b.label) {
                    return 1;
                }
                if (a.label < b.label) {
                    return -1;
                }
                return 0;
            })
            .filter((x) => !x.value.includes('10002'))
    );
};

export const normalizeServiceDeliveryCenter = (
    data: QueueServiceDeliveryCenter[],
    lang: string
): DefaultOptionType[] => {
    return (
        Array.isArray(data) &&
        data
            .sort((a, b) => {
                if (a.name[lang] > b.name[lang]) {
                    return 1;
                }
                if (a.name[lang] < b.name[lang]) {
                    return -1;
                }
                return 0;
            })
            .map((x) => ({
                label: x.name[lang],
                value: x.taxOrgCode,
                key: x.taxOrgCode,
            }))
    );
};

export const normalizeAvailableTimes = (
    data: QueueAvailableTime[],
): DefaultOptionType[] => {
    return (
        Array.isArray(data) &&
        data
            .filter((x) => x.count)
            .map((item) => {
                const formatedTime = `${dayjs(item.startsAt, 'HH:mm:ss').format('HH:mm')}-${dayjs(
                    item.endsAt,
                    'HH:mm:ss'
                ).format('HH:mm')}`;

                return {
                    value: item.startsAt,
                    label: formatedTime,
                    key: formatedTime,
                };
            })
    );
};

export const normalizeJson = (data = {}, objectKey?: string): DefaultOptionType[] => {
    try {
        if (typeof data === 'object' && Object.keys(data).length === 0) return [];
        else
            return Object.keys(data)
                .map((x) => {
                    const key = x as keyof typeof data;

                    if (objectKey && typeof data[key][objectKey] === 'string') {
                        return {
                            label: data[key][objectKey],
                            value: key,
                        };
                    } else if (typeof data[key] === 'string') {
                        return {
                            label: data[key],
                            value: key,
                        };
                    } else {
                        return null;
                    }
                })
                .filter(Boolean) as DefaultOptionType[];
    } catch (err) {
        return [];
    }
};
